import AlertDialog from "./AlertDialog";
import AlertDialogWithRef from "./AlertDialogWithRef";

export {
    AlertDialog as default,
    AlertDialogWithRef,
};
